import { render, staticRenderFns } from "./ChangeCompanyModal.vue?vue&type=template&id=55c9d45a&scoped=true&"
import script from "./ChangeCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c9d45a",
  null
  
)

export default component.exports